import { useSelector } from "react-redux";
import { utilsState } from "../../../sotre/redux/features/utilsSlice";
import DateInput from "../../../components/common/inputs/DateInput";
import UserModal from "../../../components/common/modals/user-modal/UserModal";
import { useRef, useState } from "react";
import { successMessage } from "../../../utils/toastify-message/ToastifyMessage";
import { PiXFill } from "react-icons/pi";
import CategoriesSelect from "../../../components/common/inputs/CategoriesSelect";

export default function AllOrderReportsFilter({ filterDataHandler }) {
  const { utils } = useSelector(utilsState);
  const userModalRef = useRef();

  const [user, setUser] = useState(null);

  const handleUser = (data) => {
    setUser(data.name);
    successMessage(`کاربر ${data?.name} انتخاب شد`);
    filterDataHandler({ page: 1, user: data?._id });
  };

  const deleteUser = () => {
    setUser("");
    filterDataHandler({ page: 1, user: "" });
  };
  const filterCategory = (data) => {
    filterDataHandler({ page: 1, categories: data });
  };
  return (
    <div className="w-full flex flex-col flex-wrap my-8 gap-6 px-6">
      <UserModal ref={userModalRef} handleUser={handleUser} />

      <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        <div className="w-full">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            شناسه محصول
          </label>
          <div className="relative w-full">
            <div className="absolute z-[1] inset-y-0 left-0 flex items-center px-3 pointer-events-none">
              <svg
                className="w-5 h-5 text-gray-500 dark:text-gray-400"
                aria-hidden="true"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                  clipRule="evenodd"
                ></path>
              </svg>
            </div>
            <input
              type="text"
              id="table-search"
              className="block p-2 pe-10 text-sm text-gray-900 border border-gray-300 rounded-lg w-full bg-white/50 backdrop-blur-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="جست و جو ..."
              onChange={(e) =>
                filterDataHandler({ page: 1, sku: e.target.value })
              }
            />
          </div>
        </div>
        
        <div className="w-full">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            نقش
          </label>
          <div className="relative">
            <select
              onChange={(e) =>
                filterDataHandler({ page: 1, role: e.target.value })
              }
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 pl-8 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 appearance-none"
            >
              <option value={""}>همه</option>
              {utils?.ROLES_VALUES
                ? utils?.ROLES_VALUES?.map((item) => {
                    return <option key={item?.value} value={item?.value}>{item?.name}</option>;
                  })
                : null}
            </select>
            <div className="absolute inset-y-0 left-0 flex items-center pl-2 pointer-events-none">
              <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
        </div>
        
        <div className="w-full">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            شبکه اجتماعی
          </label>
          <div className="relative">
            <select
              onChange={(e) =>
                filterDataHandler({ page: 1, socialGroup: e.target.value })
              }
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 pl-8 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 appearance-none"
            >
              <option value={""}>همه</option>
              {utils?.SOCIAL_MEDIA_TYPE_VALUES
                ? utils?.SOCIAL_MEDIA_TYPE_VALUES?.map((item) => {
                    return <option key={item?.value} value={item?.value}>{item?.name}</option>;
                  })
                : null}
            </select>
            <div className="absolute inset-y-0 left-0 flex items-center pl-2 pointer-events-none">
              <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
        </div>
        
        <div className="w-full">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            برند
          </label>
          <div className="relative">
            <select
              onChange={(e) => filterDataHandler({ page: 1, brand: e.target.value })}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 pl-8 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 appearance-none"
            >
              <option value={""}>همه</option>
              <option value={"saboora"}>صبورا</option>
              <option value={"attarbashi"}>عطارباشی</option>
            </select>
            <div className="absolute inset-y-0 left-0 flex items-center pl-2 pointer-events-none">
              <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
        </div>

        <div className="w-full">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            وضعیت مرسوله
          </label>
          <div className="relative">
            <select
              onChange={(e) =>
                filterDataHandler({ page: 1, proccessShipping: e.target.value })
              }
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 pl-8 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 appearance-none"
            >
              <option value={""}>همه</option>
              {utils?.ORDER_PROCCESS_SHIPPING_STATUS_VALUES?.map((item) => (
                <option key={item.value} value={item.value}>
                  {item.name}
                </option>
              ))}
            </select>
            <div className="absolute inset-y-0 left-0 flex items-center pl-2 pointer-events-none">
              <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
        </div>
        
        <div className="relative w-full">
          <span
            onClick={() => userModalRef?.current?.showModal()}
            className="absolute w-full h-full cursor-pointer z-10"
          ></span>
          {user ? (
            <PiXFill
              className="cursor-pointer absolute left-2 bottom-4 text-red-500 z-20"
              onClick={deleteUser}
            />
          ) : null}
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            انتخاب کاربر
          </label>
          <input
            value={user || ""}
            onChange={(e) => setUser(e.target.value)}
            disabled
            placeholder="انتخاب کاربر"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 cursor-pointer"
          />
        </div>

        <div className="w-full">
          <DateInput
            label={"از تاریخ"}
            onChange={(e) => filterDataHandler({ page: 1, from: e })}
          />
        </div>
        
        <div className="w-full">
          <DateInput
            label={"تا تاریخ"}
            onChange={(e) => filterDataHandler({ page: 1, to: e })}
          />
        </div>

        <div className="w-full">
          <CategoriesSelect onChange={filterCategory} label="انتخاب دسته بندی" />
        </div>
      </div>
    </div>
  );
}
